import PropTypes from 'prop-types';
import React from 'react';

import Flex from '../Flex';

import { CustomInput, InnerCircle, Input, Label, RadioButtonContainer } from './styles';

const Radio = ({ id, name, checked, children, onChange, containerStyle, error, ...otherProps }) => {
  return (
    <Flex {...containerStyle}>
      <RadioButtonContainer>
        <Input
          type="radio"
          id={id}
          name={name}
          onChange={onChange}
          {...otherProps}
          {...(checked !== null ? { checked } : {})}
        />
        <CustomInput error={error}>
          <InnerCircle />
        </CustomInput>
      </RadioButtonContainer>
      <Label for={id}>{children}</Label>
    </Flex>
  );
};

Radio.defaultProps = {
  checked: null,
  onChange: null,
  containerStyle: null,
  error: null
};

Radio.propTypes = {
  /**
   *  Identificator to this option
   */
  id: PropTypes.string.isRequired,
  /**
   * Field name to a set of radio buttons
   */
  name: PropTypes.string.isRequired,
  /**
   * Radio value
   */
  checked: PropTypes.bool,
  /**
   * Callback to when a change occurs
   */
  onChange: PropTypes.func,
  /**
   * Styling for the radio container, it uses styled-system naming system.
   */
  containerStyle: PropTypes.object
};

export default Radio;
